module.exports = __webpack_public_path__ + "static/logo_small-47acdbeff45adc19cb211248dd2b9bbc.png";